import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';

export const Run = () => <DirectionsRunIcon fontSize="small" />;
